import { createSelector } from '@reduxjs/toolkit'
import _identity from 'lodash/identity'
import _orderBy from 'lodash/orderBy'
import _union from 'lodash/union'

import { FILE_TYPE_DRAFT_RETURN, FILE_TYPE_SUBMITTED_RETURN, FILE_TYPE_TAX_REGISTRATION_SUBMISSION } from '../constants'

const getTaxReturnsFilesSlice = (state) => state.taxReturnFiles
const getUserFiles = (state) => state.userFiles?.items || []
const getTaxReturnFiles = (state) => getTaxReturnsFilesSlice(state).items || []

const pluckTaxReturnFilesTaxReturnId = (_, { taxReturnId }) => taxReturnId
const pluckTaxReturnFilesFileTypes = (_, { fileTypes }) => fileTypes
const pluckTaxReturnFilesFilingArea = (_, { filingArea }) => filingArea

const getTaxReturnFilesByTaxReturnId = createSelector(
    [getTaxReturnFiles, pluckTaxReturnFilesTaxReturnId],
    (taxReturnFiles, taxReturnId) => taxReturnFiles.filter((file) => file.taxReturnId === taxReturnId)
)

const getUserFilesForTaxReturn = createSelector([getUserFiles], (userFiles) => {
    const allowedFileTypes = [FILE_TYPE_TAX_REGISTRATION_SUBMISSION]
    return userFiles.filter((file) => allowedFileTypes.includes(file.fileType))
})

export const getTaxReturnDocumentsViewFiles = createSelector(
    [getTaxReturnFilesByTaxReturnId, getUserFilesForTaxReturn],
    (taxReturnFilesByTaxReturnId, userFilesForTaxReturn) => {
        const orderedTaxReturnFiles = _orderBy(
            taxReturnFilesByTaxReturnId,
            ['fileType', 'uploadedDateUTC'],
            ['asc', 'desc']
        )
        return _union(userFilesForTaxReturn, orderedTaxReturnFiles)
    }
)

export const getTaxReturnDraftReturnFileId = createSelector(
    [getTaxReturnFilesByTaxReturnId],
    (taxReturnFilesByTaxReturnId) => {
        const { id: draftReturnFileId } =
            taxReturnFilesByTaxReturnId.find((item) => item.fileType === FILE_TYPE_DRAFT_RETURN) || {}

        const hasDraftReturnFile = !!draftReturnFileId

        return {
            draftReturnFileId,
            hasDraftReturnFile,
        }
    }
)

export const getFinalTaxReturnFileId = createSelector(
    [getTaxReturnFilesByTaxReturnId],
    (taxReturnFilesByTaxReturnId) => {
        const { id: finalTaxReturnFileId } =
            taxReturnFilesByTaxReturnId.find((item) => item.fileType === FILE_TYPE_SUBMITTED_RETURN) || {}

        const hasFinalTaxReturnFile = !!finalTaxReturnFileId

        return {
            finalTaxReturnFileId,
            hasFinalTaxReturnFile,
        }
    }
)

export const getTaxReturnFilesByFilingAreaAndFileTypes = createSelector(
    [getTaxReturnFiles, pluckTaxReturnFilesFilingArea, pluckTaxReturnFilesFileTypes],
    (taxReturnFiles, filingArea, fileTypes) =>
        taxReturnFiles.filter((o) => o.filingArea === filingArea && fileTypes.includes(o.fileType))
)

export default createSelector([getTaxReturnsFilesSlice], _identity)
